export default "__VITE_ASSET__BqOzqZ2E__"